<template>
    <div class="d-flex flex-column flex-column-fluid  qbank-section">
        <!-- Toolbar -->
        <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        منصة أكاديميا Academia
                    </h1>
                    <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li class="breadcrumb-item text-muted">
                            <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
                        </li>
                        <li class="breadcrumb-item">
                            <span class="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li class="breadcrumb-item text-muted">الرئيسية</li>
                    </ul>
                </div>
                <div class="d-flex align-items-center gap-2 gap-lg-3">
                    <button @click="$router.go(-1)" class="btn btn-light"
                        style="font-weight: 600;padding: 8px 20px;margin-left: 15px;background: #d7d7d745;">
                        رجوع <i class="fa fa-arrow-left" style="color: #07c232; margin-right: 10px"></i></button>
                </div>
            </div>
        </div>

        <!-- Content -->
        <div id="kt_app_content_container" class="app-container container-fluid">
            <div v-if="isloading" class="text-center my-5">
                <div style="font-weight: 800; border-radius: 10px; padding: 50px; font-size: large; text-align: center; background: #73737326;"
                    class="loader text-success">
                    جاري التحميل
                    <div class="spinner-border text-success" role="status">
                        <span class="sr-only"></span>
                    </div>
                </div>
            </div>

            <div v-else>
                <!-- Card -->
                <div class="card shadow-sm">
                    <div class="card-header text-white" style="background:#03c044">
                        <h3 class="card-title" style="color:#fff"> إشتراك جديد </h3>
                    </div>
                    <div class="card-body">
                        <p class="text-muted"> حدد الفئة والتخصص وإختر من أدناه الباقة المناسبة لك </p>
                        <hr>
                        <!-- Categories Select -->
                        <div class="row mb-4">
                            <div class="col-md-6">
                                <label for="categoriesSelect" class="form-label">الفئات</label>
                                <select id="categoriesSelect" class="form-select" v-model="selectedCategory"
                                    @change="filterSubCategories">
                                    <option value="" disabled>اختر الفئة</option>
                                    <option v-for="category in categories" :key="category.id" :value="category.id">
                                        {{ category.title }}
                                    </option>
                                </select>
                            </div>

                            <!-- Subcategories Select -->
                            <div class="col-md-6">
                                <label for="subCategoriesSelect" class="form-label"> التخصصات</label>
                                <select id="subCategoriesSelect" class="form-select" v-model="selectedSubCategory"
                                    @change="fetchSubscriptions">
                                    <option value="" disabled>اختر التخصص</option>
                                    <option v-for="subCategory in subCategories" :key="subCategory.id"
                                        :value="subCategory.id">
                                        {{ subCategory.title }}
                                    </option>
                                    <option v-if="subCategories.length === 0" disabled>لا توجد فئات فرعية</option>
                                </select>
                            </div>
                        </div>

                        <!-- Display Subscription Plans -->
                        <div class="mt-5">
                            <h4 v-if="subscriptionPlans.data.length != 0">خطط
                                الاشتراكات</h4>
                            <div class="row g-4">
                                <div v-if="isLoading" class="text-center w-100 my-4">
                                    <div class="spinner-border text-success" role="status">
                                        <span class="visually-hidden">جاري التحميل...</span>
                                    </div>
                                    <div class="mt-2">جاري تحميل الباقات...</div>
                                </div>
                                <div v-else-if="subscriptionPlans.data.length === 0 && subCategories.length != 0"
                                    class="text-center w-100 text-muted my-4">
                                    لا توجد باقات متاحة في هذا التخصص.
                                </div>
                                <div v-else v-for="plan in subscriptionPlans.data" :key="plan.id" class="col-md-4">
                                    <div class="card shadow-sm h-100 plan-box">
                                        <div class="card-body">
                                            <h5 class="card-title">{{ plan.name }}</h5>
                                            <div class="card-text">
                                                <table class="table table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <th>المدة</th>
                                                            <td>{{ plan.duration }} يوم</td>
                                                        </tr>
                                                        <tr>
                                                            <th>السعر</th>
                                                            <td>{{ plan.price }} دينار</td>
                                                        </tr>
                                                        <tr>
                                                            <th>تجربة مجانية</th>
                                                            <td>
                                                                <span
                                                                    :class="plan.is_free_trial ? 'badge badge-primary' : 'badge badge-secondary'">
                                                                    {{ plan.is_free_trial ? 'نعم' : 'لا' }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>الحالة</th>
                                                            <td>
                                                                <span
                                                                    :class="plan.is_active ? 'badge badge-success' : 'badge badge-danger'">
                                                                    {{ plan.is_active ? 'نشط' : 'غير نشط' }}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                        <div class="card-footer text-end">
                                            <button class="btn btn-success" style="background-color: #03c044"
                                                @click="confirmSubscription(plan.id)"> إشتراك
                                                الآن <i class="fa fa-check-circle"></i> </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";
export default {
    name: "newPlan",
    data() {
        return {
            isLoading: false,

            categories: [],
            subCategories: [],
            subscriptionPlans: { data: [] },
            isloading: true,
            token: localStorage.getItem("access_token"),
            selectedCategory: "",
            selectedSubCategory: "",
        };
    },
    mounted() {
        this.fetchCategories();
    },
    methods: {
        async fetchCategories() {
            try {
                const response = await fetch(`${apiUrl}/qbanks/categories`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    this.categories = data.data;
                    this.isloading = false;
                } else {
                    console.error("Failed to fetch categories");
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
                this.isloading = false;
            }
        },
        filterSubCategories() {
            const selectedCategory = this.categories.find(
                (category) => category.id === this.selectedCategory
            );
            this.subCategories = selectedCategory
                ? selectedCategory.sub_categories
                : [];
            this.selectedSubCategory = "";
        },
        async fetchSubscriptions() {
            if (!this.selectedSubCategory) return;
            this.isLoading = true;
            try {
                const response = await fetch(
                    `${apiUrl}/qbanks/sub-categories/${this.selectedSubCategory}/subscription-plans`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    this.subscriptionPlans = data;
                    this.isLoading = false;

                } else {
                    console.error("Failed to fetch subscription plans");
                    this.subscriptionPlans = { data: [] };
                    this.isLoading = false;

                }
            } catch (error) {
                console.error("Error fetching subscription plans:", error);
                this.subscriptionPlans = { data: [] };
                this.isLoading = false;

            }
        },
        async confirmSubscription(planId) {
            const result = await Swal.fire({
                title: "هل تريد تأكيد الاشتراك؟",
                text: "إضغط موافق لتأكيد الإشتراك",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3ddc97",
                cancelButtonColor: "#f46a6a",
                cancelButtonText: "إلغاء",
                confirmButtonText: "موافق",
            });

            if (result.isConfirmed) {
                try {
                    const response = await fetch(`${apiUrl}/profile/qbanks/subscription-plans/${planId}/subscribe`, {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${this.token}`,
                            "Content-Type": "application/json",
                        },
                    });

                    if (response.ok) {
                        Swal.fire({
                            title: "تم الاشتراك بنجاح",
                            icon: "success",
                            confirmButtonText: "موافق",
                        });
                    } else {
                        const error = await response.json();
                        Swal.fire({
                            title: "خطأ",
                            text: error.message || "حدث خطأ أثناء الاشتراك.",
                            icon: "error",
                            confirmButtonText: "موافق",
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        title: "خطأ",
                        text: "تعذر إتمام العملية.",
                        icon: "error",
                        confirmButtonText:
                            "موافق",
                    });
                }
            }
        },
    },
}; </script>

<style scoped>
.card-title {
    font-size: 1.25rem;
    font-weight: 600;
}

.card-text strong {
    color: #6c757d;
}

.card-footer .btn {
    font-size: 0.9rem;
}
</style>
